import React, { Component, Fragment } from 'react';
import { Alert, Collapse } from 'react-bootstrap';
import Glitch from 'glitch-javascript-sdk';
import Header from '../../component/layout/header';
import PageHeader from '../../component/layout/pageheader';
import Footer from '../../component/layout/footer';
import withRouter from '../../../../util/withRouter';
import Loading from '../../component/alerts/Loading';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faDownload,
    faEnvelope,
    faStar,
    faChevronDown,
    faChevronUp,
    faGamepad,
    faVideo,
    faDesktop,
    faGlobe,
    faInfoCircle,
    faImages,
} from '@fortawesome/free-solid-svg-icons';

import {
    faAndroid,
    faAppStore,
    faSteam,
} from '@fortawesome/free-brands-svg-icons';
import GallerySection from '../../../marketing/component/tools/gallery';

class MediakitCommunityPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mediakit: null,
            isLoading: true,
            showAdditionalInfo: true,
            videoEmbedUrl: null,
            mediaFiles: [],
        };
    }

    componentDidMount() {
        const { id } = this.props.router.params;

        Glitch.api.Titles.view(id, { include: 'media' })
            .then((response) => {
                const mediakitData = response.data.data;
                this.setState({ mediakit: mediakitData, isLoading: false });

                // Set video embed URL based on video_url
                let videoSet = false;
                if (mediakitData.video_url) {
                    let embedUrl = null;
                    if (
                        mediakitData.video_url.includes('youtube.com') ||
                        mediakitData.video_url.includes('youtu.be')
                    ) {
                        const videoId =
                            mediakitData.video_url.split('v=')[1] ||
                            mediakitData.video_url.split('/').pop();
                        embedUrl = `https://www.youtube.com/embed/${videoId}`;
                    } else if (mediakitData.video_url.includes('vimeo.com')) {
                        const videoId = mediakitData.video_url.split('/').pop();
                        embedUrl = `https://player.vimeo.com/video/${videoId}`;
                    }
                    this.setState({ videoEmbedUrl: embedUrl });
                    videoSet = true;
                }

                // Process media files
                const media = mediakitData.media || [];
                let remainingMedia = [];
                let firstVideoMedia = null;

                // If we haven't set a "videoEmbedUrl" yet, look for the first video in the media files
                if (!videoSet) {
                    for (let i = 0; i < media.length; i++) {
                        const mediaItem = media[i];
                        if (
                            !firstVideoMedia &&
                            mediaItem.mime_type &&
                            mediaItem.mime_type.startsWith('video/')
                        ) {
                            firstVideoMedia = mediaItem;
                            // Do not push it to remainingMedia so it doesn't show up in the gallery
                            continue;
                        } else {
                            remainingMedia.push(mediaItem);
                        }
                    }
                } else {
                    remainingMedia = media;
                }

                if (!videoSet && firstVideoMedia) {
                    this.setState({ videoEmbedUrl: firstVideoMedia.url });
                }

                this.setState({ mediaFiles: remainingMedia });
            })
            .catch((error) => {
                console.error('Error fetching mediakit:', error);
                this.setState({ isLoading: false });
            });
    }

    toggleAdditionalInfo = () => {
        this.setState((prevState) => ({
            showAdditionalInfo: !prevState.showAdditionalInfo,
        }));
    };

    render() {
        const { mediakit, isLoading, showAdditionalInfo, videoEmbedUrl, mediaFiles } = this.state;

        // Loading state
        if (isLoading) {
            return (
                <Fragment>
                    <Header />
                    <PageHeader title="Media Kit" curPage="Loading..." />
                    <div className="container pt-5 pb-5">
                        <Loading />
                    </div>
                    <Footer />
                </Fragment>
            );
        }

        // If no MediaKit found
        if (!mediakit) {
            return (
                <Fragment>
                    <Header />
                    <PageHeader title="Media Kit" curPage="Not Found" />
                    <div className="container pt-5 pb-5">
                        <Alert variant="danger">Media Kit not found.</Alert>
                    </div>
                    <Footer />
                </Fragment>
            );
        }

        // Prepare store/demo links (with icons matching the Standalone layout)
        const storeLinks = [];
        if (mediakit.demo_url) {
            storeLinks.push({
                url: mediakit.demo_url,
                label: 'Download Demo',
                icon: faDownload,
            });
        }
        if (mediakit.website_url) {
            storeLinks.push({
                url: mediakit.website_url,
                label: 'Visit Website',
                icon: faDesktop,
            });
        }
        if (mediakit.steam_url) {
            storeLinks.push({
                url: mediakit.steam_url,
                label: 'Steam Store',
                icon: faSteam,
            });
        }
        if (mediakit.itch_url) {
            storeLinks.push({
                url: mediakit.itch_url,
                label: 'Itch.io Store',
                icon: faGlobe,
            });
        }
        if (mediakit.apple_url) {
            storeLinks.push({
                url: mediakit.apple_url,
                label: 'Apple App Store',
                icon: faAppStore,
            });
        }
        if (mediakit.android_url) {
            storeLinks.push({
                url: mediakit.android_url,
                label: 'Google Play Store',
                icon: faAndroid,
            });
        }

        // Determine whether to show "Game Information" section
        const showGameInformation =
            mediakit.developer ||
            mediakit.publisher ||
            mediakit.release_date ||
            mediakit.age_rating ||
            mediakit.multiplayer_options ||
            mediakit.pricing ||
            mediakit.availability ||
            (mediakit.platform_compatibility && mediakit.platform_compatibility.length > 0);

        return (
            <Fragment>
                <Header />

                {/* Fullscreen Banner */}
                {mediakit.image_banner ? (
                    <div
                        className="bg-image"
                        style={{
                            backgroundImage: `url(${mediakit.image_banner})`,
                            height: '100vh',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            position: 'relative',
                            color: 'white',
                        }}
                    >
                        <div
                            className="overlay"
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            }}
                        ></div>
                        <div
                            className="d-flex flex-column justify-content-center align-items-center h-100"
                            style={{ position: 'relative', zIndex: 1 }}
                        >
                            {mediakit.image_main && (
                                <img
                                    src={mediakit.image_main}
                                    alt={mediakit.name}
                                    className="img-fluid rounded-circle mb-3"
                                    style={{
                                        width: '200px',
                                        height: '200px',
                                        objectFit: 'cover',
                                        border: '5px solid white',
                                    }}
                                />
                            )}
                            <h1 className="display-2 text-center">{mediakit.name}</h1>
                            {mediakit.tagline && (
                                <p className="lead text-center">{mediakit.tagline}</p>
                            )}
                            <div className="mt-4">
                                {storeLinks.map((link, index) => (
                                    <a
                                        key={index}
                                        href={link.url}
                                        className={`btn btn-${
                                            index % 2 === 0 ? 'primary' : 'outline-light'
                                        } btn-lg mx-2`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FontAwesomeIcon icon={link.icon} /> {link.label}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                ) : (
                    // If no banner, we use a simple heading
                    <div className="container pt-5 pb-3 text-center">
                        <h1 className="display-4">{mediakit.name}</h1>
                        {mediakit.tagline && (
                            <p className="lead text-muted">{mediakit.tagline}</p>
                        )}
                        <div className="d-flex justify-content-center mt-4">
                            {storeLinks.map((link, index) => (
                                <a
                                    key={index}
                                    href={link.url}
                                    className={`btn btn-${
                                        index % 2 === 0 ? 'primary' : 'outline-secondary'
                                    } btn-lg mx-2`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <FontAwesomeIcon icon={link.icon} /> {link.label}
                                </a>
                            ))}
                        </div>
                    </div>
                )}

                {/* Main Content Container */}
                <div className="container py-5">
                    {/* Video Section */}
                    {videoEmbedUrl && (
                        <div className="mb-5">
                            <h2 className="text-center mb-1">
                                <FontAwesomeIcon icon={faVideo} />{' '}
                                {mediakit.image_banner ? 'Trailer' : mediakit.name}
                            </h2>
                            {videoEmbedUrl.includes('https://www.youtube.com') ||
                            videoEmbedUrl.includes('https://player.vimeo.com') ? (
                                <div className="ratio ratio-16x9 shadow-lg">
                                    <iframe
                                        src={videoEmbedUrl}
                                        title="Media Kit Video"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            ) : (
                                <div className="ratio ratio-16x9 shadow-lg">
                                    <video controls src={videoEmbedUrl} className="w-100 h-100"></video>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Fallback if no video and no media */}
                    {!videoEmbedUrl && mediaFiles.length === 0 && (
                        <div className="mb-5">
                            <h2 className="text-center mb-1">{mediakit.name}</h2>
                        </div>
                    )}

                    {/* Short Description */}
                    {mediakit.short_description && (
                        <div className="mb-5">
                            <h2 className="mb-4">
                                <FontAwesomeIcon icon={faGamepad} /> About the Game
                            </h2>
                            <div
                                className="lead text-start"
                                dangerouslySetInnerHTML={{ __html: mediakit.short_description }}
                            ></div>
                        </div>
                    )}

                    {/* Key Features */}
                    {mediakit.key_features && (
                        <div className="mb-5">
                            <h2 className="mb-4">
                                <FontAwesomeIcon icon={faStar} /> Key Features
                            </h2>
                            <div
                                className="lead"
                                dangerouslySetInnerHTML={{ __html: mediakit.key_features }}
                            ></div>
                        </div>
                    )}

                    {/* Contact Information */}
                    {(mediakit.press_contact_name || mediakit.press_contact_email) && (
                        <div className="mb-5">
                            <h2 className="mb-4">
                                <FontAwesomeIcon icon={faEnvelope} /> Press Contact
                            </h2>
                            {mediakit.press_contact_name && (
                                <p>
                                    <strong>Name:</strong> {mediakit.press_contact_name}
                                </p>
                            )}
                            {mediakit.press_contact_email && (
                                <p>
                                    <strong>Email:</strong>{' '}
                                    <a
                                        href={`mailto:${mediakit.press_contact_email}`}
                                        className="text-decoration-none"
                                    >
                                        {mediakit.press_contact_email}
                                    </a>
                                </p>
                            )}
                        </div>
                    )}

                    {/* Game Information (only if at least one field is present) */}
                    {showGameInformation && (
                        <div className="mb-5">
                            <h2 className="mb-4">
                                <FontAwesomeIcon icon={faInfoCircle} /> Game Information
                            </h2>
                            <div className="row">
                                {mediakit.developer && (
                                    <div className="col-md-4 mb-3">
                                        <strong>Developer:</strong> {mediakit.developer}
                                    </div>
                                )}
                                {mediakit.publisher && (
                                    <div className="col-md-4 mb-3">
                                        <strong>Publisher:</strong> {mediakit.publisher}
                                    </div>
                                )}
                                {mediakit.release_date && (
                                    <div className="col-md-4 mb-3">
                                        <strong>Release Date:</strong>{' '}
                                        {new Date(mediakit.release_date).toLocaleDateString()}
                                    </div>
                                )}
                                {mediakit.age_rating && (
                                    <div className="col-md-4 mb-3">
                                        <strong>Age Rating:</strong> {mediakit.age_rating}
                                    </div>
                                )}
                                {mediakit.multiplayer_options && (
                                    <div className="col-md-4 mb-3">
                                        <strong>Multiplayer Options:</strong>{' '}
                                        {mediakit.multiplayer_options}
                                    </div>
                                )}
                                {mediakit.pricing && (
                                    <div className="col-md-4 mb-3">
                                        <strong>Pricing:</strong> {mediakit.pricing_currency}{' '}
                                        {mediakit.pricing}
                                    </div>
                                )}
                                {mediakit.availability && (
                                    <div className="col-md-4 mb-3">
                                        <strong>Availability:</strong> {mediakit.availability}
                                    </div>
                                )}
                                {mediakit.platform_compatibility &&
                                    mediakit.platform_compatibility.length > 0 && (
                                        <div className="col-md-4 mb-3">
                                            <strong>Platform Compatibility:</strong>{' '}
                                            {mediakit.platform_compatibility}
                                        </div>
                                    )}
                            </div>
                        </div>
                    )}

                    {/* Media Gallery */}
                    {mediaFiles.length > 0 && (
                        <div className="mb-5">
                            <h2 className="text-center mb-4">
                                <FontAwesomeIcon icon={faImages} /> Gallery
                            </h2>
                            <GallerySection mediaFiles={mediaFiles} />
                        </div>
                    )}

                    {/* Additional Information */}
                    {(mediakit.long_description ||
                        mediakit.system_requirements ||
                        mediakit.gameplay_mechanics ||
                        mediakit.narrative_setting ||
                        mediakit.visual_audio_style ||
                        mediakit.dlc_expansion_info ||
                        mediakit.critical_reception) && (
                        <div className="mb-5">
                            <div
                                className="d-flex justify-content-between align-items-center mb-3"
                                onClick={this.toggleAdditionalInfo}
                                style={{ cursor: 'pointer' }}
                            >
                                <h2>
                                    <FontAwesomeIcon icon={faChevronDown} /> Additional Information
                                </h2>
                                <FontAwesomeIcon
                                    icon={showAdditionalInfo ? faChevronUp : faChevronDown}
                                    size="2x"
                                />
                            </div>
                            <Collapse in={showAdditionalInfo}>
                                <div>
                                    {mediakit.long_description && (
                                        <div className="mb-4">
                                            <h3>Detailed Description</h3>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: mediakit.long_description,
                                                }}
                                            ></div>
                                        </div>
                                    )}
                                    {mediakit.system_requirements && (
                                        <div className="mb-4">
                                            <h3>System Requirements</h3>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: mediakit.system_requirements,
                                                }}
                                            ></div>
                                        </div>
                                    )}
                                    {mediakit.gameplay_mechanics && (
                                        <div className="mb-4">
                                            <h3>Gameplay Mechanics</h3>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: mediakit.gameplay_mechanics,
                                                }}
                                            ></div>
                                        </div>
                                    )}
                                    {mediakit.narrative_setting && (
                                        <div className="mb-4">
                                            <h3>Narrative Setting</h3>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: mediakit.narrative_setting,
                                                }}
                                            ></div>
                                        </div>
                                    )}
                                    {mediakit.visual_audio_style && (
                                        <div className="mb-4">
                                            <h3>Visual and Audio Style</h3>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: mediakit.visual_audio_style,
                                                }}
                                            ></div>
                                        </div>
                                    )}
                                    {mediakit.dlc_expansion_info && (
                                        <div className="mb-4">
                                            <h3>DLC and Expansion Info</h3>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: mediakit.dlc_expansion_info,
                                                }}
                                            ></div>
                                        </div>
                                    )}
                                    {mediakit.critical_reception && (
                                        <div className="mb-4">
                                            <h3>Critical Reception</h3>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: mediakit.critical_reception,
                                                }}
                                            ></div>
                                        </div>
                                    )}
                                </div>
                            </Collapse>
                        </div>
                    )}
                </div>

                <div className="d-flex flex-column align-items-center text-center">
                    <img src="/android-icon-48x48.png" alt="Icon" />
                    <p className="small">
                        <a href="https://www.glitch.fun">Powered By Glitch</a>
                    </p>
                </div>

                <Footer />
            </Fragment>
        );
    }
}

export default withRouter(MediakitCommunityPage);
